module.exports = __webpack_public_path__ + "static/media/sketch.32d6dce1.svg";